import React from 'react';
import {connect} from 'react-redux';
import { TableRow, TableCell } from '@material-ui/core';
import moment from 'moment';
import CrudActions from '../../../../partials/datatable/CrudActions';
import Datatable from '../../../../partials/datatable/Datatable';
import { QuizApiService } from '../../../../services/Ananse/QuizApiService';

class QuizListing extends React.Component {
  constructor(props) {
    super(props);

    this.api = new QuizApiService();
    this.state = {
      quiz: [],
      reload: false,
      isActive: "true"
    };

    this.setQuiz = this.setQuiz.bind(this);
    this.onConfirmChangeStatus = this.onConfirmChangeStatus.bind(this);
  }

  setQuiz(quiz) {
    this.setState({ quiz });
  }

  async onConfirmChangeStatus(obj) {
    if(!obj.deletedAt){
      await this.api.delete(obj.quizId);
    }else{
      await this.api.activate(obj.quizId);
    }

    this.setState({ reload: !this.state.reload });
  }

  render() {
    window.setPageTitle(`${this.props.translate.screens.quiz.title || 'Quiz'} - Admin`);

    const headRows = [
      { label: this.props.translate.screens.quiz.list.actions },
      { column: 'Name', label: this.props.translate.screens.quiz.list.name },
      { column: 'Campaign.Name', label: this.props.translate.screens.quiz.list.campaign },
      { column: 'Language', label: this.props.translate.screens.quiz.labels.language },
      { column: 'Questions', label: this.props.translate.screens.quiz.list.questions },
      { column: 'PublishedAt', label: this.props.translate.screens.quiz.list.published },
      { column: 'ValidatedAt', label: this.props.translate.screens.quiz.list.validate },
      { column: 'CreatedAt', label: this.props.translate.screens.quiz.list.created },
      { column: 'UpdatedAt', label: this.props.translate.screens.quiz.list.updated }
    ];

    const formatRow = r => (
      <TableRow
        hover
        tabIndex={-1}
        key={r.quizId}
      >
        <TableCell>
          <CrudActions
            actions={['toggle', 'edit']}
            module='quiz'
            onConfirmChangeStatus={this.onConfirmChangeStatus}
            id={r.quizId}
            obj={r}
          />
        </TableCell>
        <TableCell scope="row">
          {r.name}
        </TableCell>
        <TableCell scope="row">
          {r.campaign?.name}
        </TableCell>
        <TableCell scope="row">
          {r.language}
        </TableCell>
        <TableCell scope="row">
          {r.questions?.length}
        </TableCell>
        <TableCell scope="row">
          {r.publishedAt ? 
            <div className="row text-success" 
              title={`${this.props.translate.defaultMessages?.publishedIn} ${moment(r.publishedAt).format('DD/MM/YYYY HH:mm')}`}
              style={{alignItems: 'center', cursor: 'default'}}
            >
              <span className="material-icons"> 
                check
              </span>
              <span>{ moment(r.publishedAt).format('DD/MM/YYYY')}</span>
            </div>
            : ''
          }
        </TableCell>
        <TableCell scope="row">
          {r.validatedAt 
            ?  <div className="row text-dark"
                title={`${this.props.translate.defaultMessages?.validatedIn} ${moment(r.validatedAt).format('DD/MM/YYYY HH:mm')}`}
                style={{alignItems: 'center', cursor: 'default'}}
              >
                <span className="material-icons"> 
                  query_builder
                </span>
                <span>{ moment(r.validatedAt).format('DD/MM/YYYY')}</span>
              </div>
            : ''
          }
        </TableCell>
        <TableCell scope="row">
          {moment(r.createdAt).format('DD/MM/YYYY HH:mm')}
        </TableCell>
        <TableCell scope="row">
          {moment(r.updatedAt).format('DD/MM/YYYY HH:mm')}
        </TableCell>
      </TableRow>
    );

    return (
      <Datatable
        title={this.props.translate.screens.quiz.list.title}
        endpoint='/quiz'
        headRows={headRows}
        formatRow={formatRow}
        rows={this.state.quiz}
        setRows={this.setQuiz}
        reload={this.state.reload}
        placeholderSearch={this.props.translate.screens.quiz.placeholders.search}
        isActive={this.state.isActive}
        buttons={[
          {
            label: this.props.translate.datatable.add,
            onClick: null,
            icone: 'add',
            path: '/admin/quiz/create'
          }
        ]}
      />
    );
  }
}

const mapStoreToProps = store => ({
  i18n : store.i18n
});

export default connect(mapStoreToProps, null)(QuizListing);
